import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const DeliveryMethodsConfigurationSkeleton = () => {
  return (
    <Styles.Container>
      <Skeleton variant="text" width="100%" height={20} />

      <Styles.FiltersRow>
        <Skeleton variant="rounded" width={280} height={40} />
        <Skeleton variant="rounded" width={120} height={32} />
        <Skeleton variant="rounded" width={120} height={32} />
      </Styles.FiltersRow>

      <Styles.MethodsList>
        {Array.from({ length: 5 }).map((_, index) => (
          <Styles.MethodRow key={index}>
            <Skeleton variant="rounded" width={24} height={24} />
            <Styles.MethodBox>
              <Styles.MethodBoxText>
                <Skeleton variant="text" width={240} height={20} />
                <Skeleton variant="text" width="50%" height={16} />
              </Styles.MethodBoxText>
              <Skeleton variant="circular" width={24} height={24} />
            </Styles.MethodBox>
          </Styles.MethodRow>
        ))}
      </Styles.MethodsList>

      <Skeleton variant="rounded" width="100%" height={48} />

      <Styles.LoadMoreContainer>
        <Skeleton variant="rounded" width={160} height={32} />
      </Styles.LoadMoreContainer>

      <Skeleton variant="rounded" width={220} height={40} />
    </Styles.Container>
  )
}

export default DeliveryMethodsConfigurationSkeleton
